var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-teams-board"},_vm._l((_vm.items),function(item){return _c('div',{key:item.role,staticClass:"group-teams-board__item"},[_c('span',{staticClass:"group-teams-board__item__role"},[_vm._v(_vm._s(item.role)+" : ")]),_c('span',{staticClass:"group-teams-board__item__name"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }